const binding = { modules: {}, dataActions: {} };

    (binding.modules['ecomm-calendar'] = {
        c: () => require('partner/modules/ecomm-calendar/ecomm-calendar.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'ecomm-calendar',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/ecomm-calendar'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|ecomm-calendar|ecomm-calendar'] = {
                c: () => require('partner/modules/ecomm-calendar/ecomm-calendar.view.tsx'),
                cn: '__local__-__local__-ecomm-calendar'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };